import { Injectable } from "@angular/core";
import { createClient } from '@supabase/supabase-js';
import { environment } from "src/environments/environment";

@Injectable({
    providedIn: "root"
})
export class ClassificationReporterService {
    supabase = createClient(environment.SUPABASE_URL, environment.SUPABASE_KEY)

    /**
     * Report a wrong classification.
     *
     * @param text - The text that was incorrectly classified.
     * @param wrongClass - The incorrectly assigned class.
     * @param correctClass - The correct class for the text.
     * @param attribute - The attribute that was corrected.
     * @param token - The user's token that made the rectification.
     */
    async reportWrongClassification(text: string, wrongClass: string, correctClass: string, attribute: string, token: string) {
        const { error } = await this.supabase
            .from('wrong_classifications')
            .insert({
                token,
                text,
                wrong_class: wrongClass,
                correct_class: correctClass,
                attribute_corrected: attribute
            })
        const suffix = attribute[0].toUpperCase() + attribute.slice(1)
        if (error === null)
            console.log([`reportWrong${suffix}`, { wrongClass, correctClass }])
        else
            console.log([`reportWrong${suffix} - Error`, error])
    }

}
